export interface PurchaseOrder {
  id: string
  supplierId: string
  supplierName: string
  status:
    | 'draft'
    | 'issued'
    | 'acknowledged'
    | 'partially-confirmed'
    | 'confirmed'
    | 'in-transit'
    | 'partially-received'
    | 'received'
    | 'closed'
    | 'cancelled'
    | 'change-requested'
  orderDate: string
  deliveryDate: string
  totalAmount: number
  currency: string
  lineItems: number
  deliveryAddress: string
  incoterms: string
  buyerName: string
  department: string
  urgency: 'standard' | 'urgent' | 'critical'
  lastUpdated: string
  acknowledgementDue?: string
  changeRequestReason?: string
}

export interface POLineItem {
  lineNo: number
  poId: string
  materialCode: string
  description: string
  quantity: number
  unit: string
  unitPrice: number
  totalPrice: number
  requestedDate: string
  confirmedDate?: string
  confirmedQty?: number
  status: 'open' | 'confirmed' | 'partial' | 'shipped' | 'received' | 'rejected'
}

export const purchaseOrders: PurchaseOrder[] = [
  {
    id: 'PO-2026-00142',
    supplierId: 'SUP-001',
    supplierName: 'Oceanic Harvest Pte Ltd',
    status: 'issued',
    orderDate: '2026-03-14',
    deliveryDate: '2026-03-21',
    totalAmount: 45200,
    currency: 'SGD',
    lineItems: 6,
    deliveryAddress: 'FPG DC Jurong, 21 Jalan Buroh',
    incoterms: 'DDP Singapore',
    buyerName: 'Rachel Tan',
    department: 'Fresh Procurement',
    urgency: 'standard',
    lastUpdated: '2026-03-14',
    acknowledgementDue: '2026-03-16',
  },
  {
    id: 'PO-2026-00141',
    supplierId: 'SUP-002',
    supplierName: 'Golden Fields Agriculture',
    status: 'acknowledged',
    orderDate: '2026-03-13',
    deliveryDate: '2026-03-18',
    totalAmount: 128500,
    currency: 'SGD',
    lineItems: 12,
    deliveryAddress: 'FPG DC Benoi, 15 Benoi Crescent',
    incoterms: 'CIF Singapore',
    buyerName: 'Rachel Tan',
    department: 'Fresh Procurement',
    urgency: 'urgent',
    lastUpdated: '2026-03-14',
  },
  {
    id: 'PO-2026-00140',
    supplierId: 'SUP-003',
    supplierName: 'Pacific Meats International',
    status: 'in-transit',
    orderDate: '2026-03-10',
    deliveryDate: '2026-03-20',
    totalAmount: 312000,
    currency: 'SGD',
    lineItems: 8,
    deliveryAddress: 'FPG Cold Store Pandan, 8 Pandan Loop',
    incoterms: 'CIF Singapore',
    buyerName: 'David Ng',
    department: 'Meat & Seafood',
    urgency: 'standard',
    lastUpdated: '2026-03-15',
  },
  {
    id: 'PO-2026-00139',
    supplierId: 'SUP-004',
    supplierName: 'NutriPack Solutions',
    status: 'change-requested',
    orderDate: '2026-03-09',
    deliveryDate: '2026-03-25',
    totalAmount: 67800,
    currency: 'SGD',
    lineItems: 15,
    deliveryAddress: 'FPG DC Jurong, 21 Jalan Buroh',
    incoterms: 'DDP Singapore',
    buyerName: 'Michelle Wong',
    department: 'Packaged Goods',
    urgency: 'standard',
    lastUpdated: '2026-03-14',
    changeRequestReason: 'Quantity adjustment on 3 line items',
  },
  {
    id: 'PO-2026-00138',
    supplierId: 'SUP-005',
    supplierName: 'Evergreen Label Manufacturing',
    status: 'confirmed',
    orderDate: '2026-03-08',
    deliveryDate: '2026-03-28',
    totalAmount: 189000,
    currency: 'SGD',
    lineItems: 20,
    deliveryAddress: 'FPG DC Benoi, 15 Benoi Crescent',
    incoterms: 'FOB Bangkok',
    buyerName: 'Michelle Wong',
    department: 'Private Label',
    urgency: 'standard',
    lastUpdated: '2026-03-12',
  },
  {
    id: 'PO-2026-00137',
    supplierId: 'SUP-006',
    supplierName: 'MedWell Pharma Distribution',
    status: 'partially-received',
    orderDate: '2026-03-05',
    deliveryDate: '2026-03-15',
    totalAmount: 234500,
    currency: 'SGD',
    lineItems: 25,
    deliveryAddress: 'FPG Pharma Warehouse, 5 Tuas Ave 1',
    incoterms: 'DDP Singapore',
    buyerName: 'Kevin Teo',
    department: 'Pharmacy',
    urgency: 'urgent',
    lastUpdated: '2026-03-15',
  },
  {
    id: 'PO-2026-00136',
    supplierId: 'SUP-008',
    supplierName: 'SwiftHaul Logistics',
    status: 'confirmed',
    orderDate: '2026-03-07',
    deliveryDate: '2026-03-16',
    totalAmount: 18500,
    currency: 'SGD',
    lineItems: 1,
    deliveryAddress: 'Various FPG Stores',
    incoterms: 'DDP Singapore',
    buyerName: 'David Ng',
    department: 'Logistics',
    urgency: 'standard',
    lastUpdated: '2026-03-10',
  },
  {
    id: 'PO-2026-00135',
    supplierId: 'SUP-012',
    supplierName: 'Sunrise Dairy Co-op',
    status: 'in-transit',
    orderDate: '2026-03-06',
    deliveryDate: '2026-03-17',
    totalAmount: 156000,
    currency: 'SGD',
    lineItems: 10,
    deliveryAddress: 'FPG Cold Store Pandan, 8 Pandan Loop',
    incoterms: 'CIF Singapore',
    buyerName: 'Rachel Tan',
    department: 'Fresh Procurement',
    urgency: 'standard',
    lastUpdated: '2026-03-14',
  },
  {
    id: 'PO-2026-00134',
    supplierId: 'SUP-013',
    supplierName: 'Bintang Raya Foods',
    status: 'acknowledged',
    orderDate: '2026-03-04',
    deliveryDate: '2026-03-22',
    totalAmount: 95600,
    currency: 'SGD',
    lineItems: 18,
    deliveryAddress: 'FPG DC Jurong, 21 Jalan Buroh',
    incoterms: 'CIF Singapore',
    buyerName: 'Michelle Wong',
    department: 'Packaged Goods',
    urgency: 'standard',
    lastUpdated: '2026-03-08',
  },
  {
    id: 'PO-2026-00133',
    supplierId: 'SUP-010',
    supplierName: 'EcoPack Asia',
    status: 'issued',
    orderDate: '2026-03-12',
    deliveryDate: '2026-03-30',
    totalAmount: 42300,
    currency: 'SGD',
    lineItems: 5,
    deliveryAddress: 'FPG DC Benoi, 15 Benoi Crescent',
    incoterms: 'FOB Ho Chi Minh',
    buyerName: 'Michelle Wong',
    department: 'Packaging',
    urgency: 'standard',
    lastUpdated: '2026-03-12',
    acknowledgementDue: '2026-03-17',
  },
  {
    id: 'PO-2026-00132',
    supplierId: 'SUP-001',
    supplierName: 'Oceanic Harvest Pte Ltd',
    status: 'received',
    orderDate: '2026-03-01',
    deliveryDate: '2026-03-08',
    totalAmount: 38700,
    currency: 'SGD',
    lineItems: 5,
    deliveryAddress: 'FPG DC Jurong, 21 Jalan Buroh',
    incoterms: 'DDP Singapore',
    buyerName: 'Rachel Tan',
    department: 'Fresh Procurement',
    urgency: 'standard',
    lastUpdated: '2026-03-08',
  },
  {
    id: 'PO-2026-00131',
    supplierId: 'SUP-011',
    supplierName: 'CleanPro Services',
    status: 'confirmed',
    orderDate: '2026-02-28',
    deliveryDate: '2026-03-15',
    totalAmount: 24800,
    currency: 'SGD',
    lineItems: 3,
    deliveryAddress: 'Various FPG Stores',
    incoterms: 'DDP Singapore',
    buyerName: 'Jason Ong',
    department: 'Facilities',
    urgency: 'standard',
    lastUpdated: '2026-03-02',
  },
]

export const poLineItems: POLineItem[] = [
  {
    lineNo: 1,
    poId: 'PO-2026-00142',
    materialCode: 'SEA-PRW-001',
    description: 'Fresh Tiger Prawns (Grade A) 1kg',
    quantity: 200,
    unit: 'KG',
    unitPrice: 32,
    totalPrice: 6400,
    requestedDate: '2026-03-21',
    status: 'open',
  },
  {
    lineNo: 2,
    poId: 'PO-2026-00142',
    materialCode: 'SEA-SAL-002',
    description: 'Norwegian Salmon Fillet 500g',
    quantity: 150,
    unit: 'PKT',
    unitPrice: 28,
    totalPrice: 4200,
    requestedDate: '2026-03-21',
    status: 'open',
  },
  {
    lineNo: 3,
    poId: 'PO-2026-00142',
    materialCode: 'SEA-SQD-003',
    description: 'Fresh Squid (Cleaned) 500g',
    quantity: 300,
    unit: 'PKT',
    unitPrice: 15,
    totalPrice: 4500,
    requestedDate: '2026-03-21',
    status: 'open',
  },
  {
    lineNo: 4,
    poId: 'PO-2026-00142',
    materialCode: 'SEA-CRB-004',
    description: 'Sri Lankan Crab (Live) per KG',
    quantity: 100,
    unit: 'KG',
    unitPrice: 68,
    totalPrice: 6800,
    requestedDate: '2026-03-21',
    status: 'open',
  },
  {
    lineNo: 5,
    poId: 'PO-2026-00142',
    materialCode: 'SEA-MSL-005',
    description: 'Green Lip Mussels 1kg',
    quantity: 250,
    unit: 'KG',
    unitPrice: 22,
    totalPrice: 5500,
    requestedDate: '2026-03-21',
    status: 'open',
  },
  {
    lineNo: 6,
    poId: 'PO-2026-00142',
    materialCode: 'SEA-FLT-006',
    description: 'Barramundi Fillet (Fresh) 300g',
    quantity: 400,
    unit: 'PKT',
    unitPrice: 44.5,
    totalPrice: 17800,
    requestedDate: '2026-03-21',
    status: 'open',
  },
]

export function getOrdersBySupplier(supplierId: string): PurchaseOrder[] {
  return purchaseOrders.filter((po) => po.supplierId === supplierId)
}

export function getOrderById(id: string): PurchaseOrder | undefined {
  return purchaseOrders.find((po) => po.id === id)
}

export function getLineItemsByPO(poId: string): POLineItem[] {
  return poLineItems.filter((li) => li.poId === poId)
}
